// SystemDeviceHardware Saga
import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  SDHW_GET_LIST,
  SDHW_GET_DATA,
  SDHW_GET_READER_STATUS,
  SDHW_TEST_READER,
} from "./actionType";

import {
  getSystemDeviceHardwareListSuccess,
  getSystemDeviceHardwareListFailure,
  getSystemDeviceHardwareDataSuccess,
  getSystemDeviceHardwareDataFailure,
  getSystemDeviceReaderStatusSuccess,
  getSystemDeviceReaderStatusFailure,
  testSystemDeviceReaderSuccess,
  testSystemDeviceReaderFailure,
} from "./action";

import {
  getSystemDeviceHardwareListAPI,
  getSystemDeviceHardwareDataAPI,
  getSystemDeviceReaderStatusAPI,
  testSystemDeviceReaderAPI,
} from "../../helpers/fakebackend_helper";

function* listWorker() {
  try {
    const response = yield call(getSystemDeviceHardwareListAPI);
    yield put(getSystemDeviceHardwareListSuccess(response));
  } catch (error) {
    yield put(getSystemDeviceHardwareListFailure(error));
  }
}

function* dataWorker(action) {
  try {
    const response = yield call(getSystemDeviceHardwareDataAPI, action.payload);
    yield put(getSystemDeviceHardwareDataSuccess(response));
  } catch (error) {
    yield put(getSystemDeviceHardwareDataFailure(error));
  }
}

function* readerStatusWorker(action) {
  const id = action.payload?.id;
  try {
    const response = yield call(getSystemDeviceReaderStatusAPI, action.payload);
    yield put(getSystemDeviceReaderStatusSuccess({ id, response }));
  } catch (error) {
    yield put(getSystemDeviceReaderStatusFailure({ id, error }));
  }
}

function* testReaderWorker(action) {
  const id = action.payload?.id;
  try {
    const response = yield call(testSystemDeviceReaderAPI, action.payload);
    yield put(testSystemDeviceReaderSuccess({ id, response }));
  } catch (error) {
    yield put(testSystemDeviceReaderFailure({ id, error }));
  }
}

function* SystemDeviceHardwareSaga() {
  yield all([
    fork(function* () {
      yield takeEvery(SDHW_GET_LIST, listWorker);
    }),
    fork(function* () {
      yield takeEvery(SDHW_GET_DATA, dataWorker);
    }),
    fork(function* () {
      yield takeEvery(SDHW_GET_READER_STATUS, readerStatusWorker);
    }),
    fork(function* () {
      yield takeEvery(SDHW_TEST_READER, testReaderWorker);
    }),
  ]);
}

export default SystemDeviceHardwareSaga;
